export const privacyPolicyDocument = {
  title: "Privacy Policy",
  badge: "Play Store Required",
  lastUpdated: "19 April 2026",
  meta: "Applies to website, mobile web, and Android app users",
  intro:
    "This Privacy Policy explains what information Aarogyam Rahita collects, how that information is used, and what choices users have when using the app, website, and related services.",
  sections: [
    {
      heading: "1. Information We Collect",
      paragraphs: [
        "We may collect account details such as your name, phone number, email address, delivery address, and login credentials when you create an account or place an order.",
        "We also process order history, cart activity, support messages, and technical usage data needed to keep the service secure and operational."
      ],
      list: [
        "Contact information provided during signup, checkout, or profile updates",
        "Delivery and billing information required to fulfill orders",
        "Device, browser, IP, and app usage information used for analytics and fraud prevention",
        "Media or documents you choose to upload for support, profile, or order resolution"
      ]
    },
    {
      heading: "2. How We Use Data",
      paragraphs: [
        "Personal data is used only for legitimate business purposes connected to the service."
      ],
      list: [
        "To create and manage user accounts",
        "To process orders, payments, invoices, and deliveries",
        "To provide customer support and resolve complaints",
        "To improve app features, performance, reliability, and security",
        "To send important service updates, order notifications, and policy changes"
      ]
    },
    {
      heading: "3. Data Sharing",
      paragraphs: [
        "We do not sell personal information. Data may only be shared with service providers who help run the platform, such as payment processors, delivery partners, hosting vendors, analytics providers, and legally required authorities."
      ],
      note:
        "Any third-party access is limited to what is reasonably required to deliver the service, comply with law, prevent fraud, or protect users and the platform."
    },
    {
      heading: "4. Permissions and App Access",
      paragraphs: [
        "If the Android app requests access to device capabilities such as storage, camera, or notifications, those permissions are used only for the corresponding app feature, for example uploading images, receiving order updates, or saving documents."
      ],
      note:
        "Users can manage permissions from their device settings. Disabling some permissions may limit related features."
    },
    {
      heading: "5. Retention and Security",
      paragraphs: [
        "We retain information for as long as needed to provide services, maintain invoices and records, resolve disputes, and meet legal or tax obligations.",
        "Reasonable administrative, technical, and operational safeguards are used to protect stored information, but no system can guarantee absolute security."
      ]
    },
    {
      heading: "6. Your Rights and Choices",
      paragraphs: [
        "You may review or update basic profile data from your account. You may also request account deletion or ask privacy-related questions using the support channels listed in the app."
      ],
      list: [
        { label: "Account & Data Deletion", to: "/account-deletion", description: "Request removal of your account and associated personal data" },
        { label: "Contact Us", to: "/contact", description: "Use the public contact form for privacy or support requests" }
      ]
    },
    {
      heading: "7. Children",
      paragraphs: [
        "The service is not intended for children who cannot legally use online commerce services without guardian supervision. If you believe personal data of a child has been provided inappropriately, contact us so the matter can be reviewed."
      ]
    }
  ],
  footerNote:
    "For privacy questions or data requests, use the Contact Us page or submit an account deletion request through the dedicated Account & Data Deletion page."
};

export const termsDocument = {
  title: "TERMS & CONDITIONS",
  badge: "आरोग्यम रहिता",
  lastUpdated: "10 May 2026",
  meta: "Website Usage, Orders, Products & Services",
  intro:
    "Welcome to Aarogyam Rahita / आरोग्यम रहिता. By using our website, placing an order, contacting us, downloading information, or using any product/service information available on this website, you agree to follow these Terms & Conditions. Please read them carefully.",

  sections: [
    {
      heading: "1. ABOUT AAROGYAM RAHITA",
      paragraphs: [
        "आरोग्यम रहिता एक स्वास्थ्यवर्धक खाद्य एवं जीवनशैली ब्रांड है, जो शुद्ध भोजन सामग्री, पारंपरिक उत्पादन पद्धति, भोजन विज्ञान, क्लस्टर आधारित फूड प्लानिंग और 21 दिन ट्रांसफॉर्मेशन सिस्टम की सोच पर कार्य करता है।",
        "हमारा उद्देश्य लोगों को शुद्ध, पाचक, संतुलित और स्वास्थ्यवर्धक भोजन जीवनशैली की दिशा में सहायता देना है।"
      ]
    },

    {
      heading: "2. WEBSITE INFORMATION",
      paragraphs: [
        "इस वेबसाइट पर दी गई जानकारी सामान्य जागरूकता, उत्पाद जानकारी, भोजन विज्ञान, जीवनशैली मार्गदर्शन और ब्रांड परिचय के उद्देश्य से दी गई है।",
        "हम वेबसाइट पर उपलब्ध जानकारी को सही और अपडेट रखने का प्रयास करते हैं, लेकिन किसी भी जानकारी की पूर्णता, उपलब्धता या बिना त्रुटि होने की गारंटी नहीं दी जाती।",
        "वेबसाइट की सामग्री समय-समय पर बिना पूर्व सूचना के अपडेट, बदली या हटाई जा सकती है।"
      ]
    },

    {
      heading: "3. HEALTH & MEDICAL DISCLAIMER",
      paragraphs: [
        "आरोग्यम रहिता किसी भी बीमारी के निदान, उपचार, चिकित्सा या पूर्ण समाधान का दावा नहीं करता।",
        "हमारे उत्पाद, डाइट प्लान, क्लस्टर सिस्टम, हर्बल सपोर्ट या 21 दिन ट्रांसफॉर्मेशन सिस्टम स्वास्थ्यवर्धक भोजन और संतुलित जीवनशैली की दिशा में सहायक प्रयास हैं।",
        "किसी भी बीमारी, दवा, एलर्जी, गर्भावस्था, गंभीर स्वास्थ्य स्थिति, बच्चों, बुजुर्गों या विशेष मेडिकल कंडीशन में किसी भी उत्पाद, डाइट या हर्बल सपोर्ट का उपयोग करने से पहले योग्य डॉक्टर, डाइटिशियन या हेल्थ एक्सपर्ट से सलाह लेना आवश्यक है।",
        "परिणाम व्यक्ति की उम्र, शरीर की प्रकृति, पाचन क्षमता, जीवनशैली, अनुशासन, स्वास्थ्य स्थिति और नियमितता पर निर्भर कर सकते हैं।"
      ]
    },

    {
      heading: "4. PRODUCT INFORMATION",
      paragraphs: [
        "आरोग्यम रहिता में शुद्ध आटा, दलिया, खिचड़ी मिक्स, दालें, मसाले, तेल, अचार, सिरका, व्रत किट, आंवला उत्पाद, हर्बल फूड सपोर्ट और अन्य स्वास्थ्यवर्धक खाद्य सामग्री उपलब्ध कराई जा सकती है।",
        "उत्पादों की उपलब्धता, पैकिंग, मात्रा, कीमत, सामग्री, स्वाद और वैरिएंट समय-समय पर बदल सकते हैं।",
        "उत्पाद की final जानकारी product label, invoice, packaging या official confirmation के अनुसार मानी जाएगी।"
      ]
    },

    {
      heading: "5. FOOD SAFETY & QUALITY",
      paragraphs: [
        "हम अपने उत्पादों में शुद्धता, गुणवत्ता और सुरक्षित प्रक्रिया का ध्यान रखने का प्रयास करते हैं।",
        "जहाँ लागू हो, खाद्य सुरक्षा, पैकिंग, लेबलिंग और संबंधित नियमों का पालन करने का प्रयास किया जाता है।",
        "ग्राहक को सलाह दी जाती है कि product label, ingredients, expiry/best before date, storage instructions और allergen information को उपयोग से पहले ध्यानपूर्वक पढ़ें।"
      ]
    },

    {
      heading: "6. ALLERGY & INDIVIDUAL SUITABILITY",
      paragraphs: [
        "कुछ उत्पादों में अनाज, दालें, बीज, मसाले, तेल, आंवला, हर्बल सामग्री या अन्य प्राकृतिक ingredients हो सकते हैं।",
        "यदि आपको किसी ingredient से allergy, intolerance या sensitivity है, तो product इस्तेमाल करने से पहले label और expert advice अवश्य लें।",
        "आरोग्यम रहिता किसी व्यक्ति की व्यक्तिगत allergy या शरीर की अलग प्रतिक्रिया के लिए जिम्मेदार नहीं होगा, यदि ग्राहक ने product information और expert advice को ध्यान में नहीं रखा।"
      ]
    },

    {
      heading: "7. CLUSTER SYSTEM & 21 DAY TRANSFORMATION SYSTEM",
      paragraphs: [
        "Cluster-Based Food Planning और 21 दिन ट्रांसफॉर्मेशन सिस्टम आरोग्यम रहिता की भोजन विज्ञान आधारित जीवनशैली प्रणाली का हिस्सा हैं।",
        "यह कोई medical treatment या guaranteed result program नहीं है।",
        "यह सही भोजन, सही routine, पाचन, संतुलन और जागरूकता की दिशा में एक structured lifestyle-support system है।",
        "किसी भी व्यक्ति को system अपनाने से पहले अपनी health condition, medical history और body suitability को ध्यान में रखना चाहिए।"
      ]
    },

    {
      heading: "8. ORDERS & ACCEPTANCE",
      paragraphs: [
        "Website, phone, WhatsApp, app या अन्य माध्यम से किया गया order उपलब्धता और confirmation पर निर्भर करेगा।",
        "Order place करने के बाद भी यदि product unavailable है, pricing error है या delivery संभव नहीं है, तो आरोग्यम रहिता order cancel या modify करने का अधिकार रखता है।",
        "Order confirmation मिलने के after ही order final माना जाएगा।"
      ]
    },

    {
      heading: "9. PRICING & PAYMENT",
      paragraphs: [
        "सभी prices समय-समय पर बदल सकते हैं।",
        "Website पर दिखाई गई price, offer या discount में कभी-कभी technical error हो सकता है। ऐसी स्थिति में final confirmed price ही मान्य होगी।",
        "Payment online, cash, UPI, bank transfer या उपलब्ध payment method के अनुसार स्वीकार किया जा सकता है।"
      ]
    },

    {
      heading: "10. DELIVERY & SHIPPING",
      paragraphs: [
        "Delivery location, product availability, courier service और local conditions के अनुसार delivery time बदल सकता है।",
        "हम समय पर delivery का प्रयास करते हैं, लेकिन courier delay, मौसम, festival rush, address issue, natural disturbance या अन्य कारणों से delay हो सकता है।",
        "ग्राहक को सही नाम, mobile number, address और delivery details देना आवश्यक है।",
        "गलत address या unavailable customer के कारण delivery fail होने पर extra delivery charges लागू हो सकते हैं।"
      ]
    },

    {
      heading: "11. CANCELLATION",
      paragraphs: [
        "Order cancellation product status पर निर्भर करेगी।",
        "यदि order packing या dispatch से पहले cancel किया जाता है, तो cancellation request consider की जा सकती है।",
        "Dispatch के बाद cancellation संभव हो या न हो, यह courier status और product nature पर निर्भर करेगा।"
      ]
    },

    {
      heading: "12. RETURN, REPLACEMENT & REFUND",
      paragraphs: [
        "Food products होने के कारण open, used, damaged after delivery, tampered या improper storage वाले products return नहीं किए जा सकते।",
        "Return या replacement केवल निम्न स्थिति में consider किया जा सकता है:"
      ],
      list: [
        "गलत product मिला हो",
        "product damaged condition में मिला हो",
        "product expired या clearly defective हो",
        "packaging delivery के समय visibly damaged हो",
        "Customer को delivery के 24 hours के अंदर photo/video proof के साथ complaint register करनी होगी।",
        "Refund, replacement या store credit का निर्णय product condition, proof और internal verification के बाद लिया जाएगा।",
        "Refund approved होने पर payment source या agreed method के माध्यम से process किया जाएगा।"
      ]
    },

    {
      heading: "13. CUSTOMER RESPONSIBILITY",
      paragraphs: [
        "Customer की जिम्मेदारी होगी कि वह:"
      ],
      list: [
        "Product label और instructions पढ़े",
        "Allergy या health condition होने पर expert advice ले",
        "Product को सही storage condition में रखे",
        "Expiry/best before date का ध्यान रखे",
        "Website या app का गलत उपयोग न करे",
        "झूठी complaint, fake claim या misuse न करे"
      ]
    },

    {
      heading: "14. USE OF WEBSITE",
      paragraphs: [
        "User वेबसाइट का उपयोग केवल lawful और personal purpose के लिए कर सकता है।",
        "User वेबसाइट पर उपलब्ध content को बिना अनुमति copy, modify, reproduce, sell, misuse या misleading context में use नहीं कर सकता।",
        "Website की security, server, content, design, database या functionality में छेड़छाड़ करना सख्त मना है।"
      ]
    },

    {
      heading: "15. INTELLECTUAL PROPERTY",
      paragraphs: [
        "Website पर उपलब्ध logo, brand name, text, images, design, content, graphics, product names, system names, cluster concept और 21 दिन ट्रांसफॉर्मेशन सिस्टम से संबंधित सामग्री आरोग्यम रहिता / उसके owners की intellectual property हो सकती है।",
        "बिना written permission के इस सामग्री का commercial use, copying या reproduction अनुमति नहीं है।"
      ]
    },

    {
      heading: "16. THIRD-PARTY LINKS",
      paragraphs: [
        "Website पर कभी-कभी third-party links, payment gateway, delivery partner, social media links या external pages हो सकते हैं।",
        "ऐसे external websites या services की privacy, security, content या policy के लिए आरोग्यम रहिता जिम्मेदार नहीं होगा।"
      ]
    },

    {
      heading: "17. LIMITATION OF LIABILITY",
      paragraphs: [
        "आरोग्यम रहिता website use, product misuse, wrong storage, allergy, individual body reaction, delayed delivery, incorrect user information, third-party service issue या information interpretation से होने वाले किसी direct/indirect loss के लिए जिम्मेदार नहीं होगा, जहाँ गलती customer side, third party या uncontrollable situation से हो।"
      ]
    },

    {
      heading: "18. OFFERS & PROMOTIONS",
      paragraphs: [
        "Offers, discounts, combos, kits, workshops या special programs limited period और availability के आधार पर हो सकते हैं।",
        "आरोग्यम रहिता किसी भी offer को बदलने, रोकने या withdraw करने का अधिकार रखता है।"
      ]
    },

    {
      heading: "19. PRIVACY",
      paragraphs: [
        "Customer data का उपयोग order processing, delivery, customer support, service improvement और communication के लिए किया जा सकता है।",
        "User की privacy से संबंधित विस्तृत जानकारी हमारी Privacy Policy में दी जा सकती है।"
      ]
    },

    {
      heading: "20. CHANGES TO TERMS",
      paragraphs: [
        "आरोग्यम रहिता इन Terms & Conditions को समय-समय पर बदल या update कर सकता है।",
        "Updated terms website पर publish होने के बाद लागू माने जाएँगे।",
        "User को समय-समय पर इस page को review करना चाहिए।"
      ]
    },

    {
      heading: "21. GOVERNING LAW & JURISDICTION",
      paragraphs: [
        "ये Terms & Conditions भारत के लागू कानूनों के अनुसार संचालित माने जाएँगे।",
        "किसी भी विवाद की स्थिति में संबंधित jurisdiction Meerut, Uttar Pradesh / India के competent courts के अधीन हो सकती है, जब तक applicable law कुछ और निर्धारित न करे।"
      ]
    },

    {
      heading: "22. CONTACT US",
      paragraphs: [
        "किसी भी order, product, complaint, return, refund या website-related query के लिए आप हमसे संपर्क कर सकते हैं:"
      ],
      list: [
        "Aarogyam Rahita / आरोग्यम रहिता",
        "Address: C-3, Sainik Vihar, Nangla Tashi, Kankarkhera, Meerut, Uttar Pradesh",
        "Website: www.aarogyamrahita.com",
        "App: Aarogyam Rahita",
        "Mobile: 8979444801"
      ]
    }
  ],

  footerNote:
    "IMPORTANT NOTE: यह Terms & Conditions draft website use के लिए तैयार किया गया है। Final legal publishing से पहले इसे अपने business model, FSSAI details, GST details, payment gateway, refund policy और legal advisor के अनुसार review/update कर लेना बेहतर रहेगा।"
};

export const refundDocument = {
  title: "Return & Refund Policy",
  badge: "Customer Protection",
  lastUpdated: "19 April 2026",
  meta: "Orders placed through app and website",
  intro:
    "This policy explains when orders can be cancelled, how returns are handled, and when refunds are processed for purchases made through Aarogyam Rahita.",
  sections: [
    {
      heading: "1. Eligible Returns",
      paragraphs: [
        "Return eligibility depends on the product type, its condition at delivery, and the reason for the request.",
        "Items must generally be unused and returned with original packaging unless the request is due to a defect, damage, or delivery issue."
      ],
      list: [
        "Damaged or defective items reported promptly after delivery",
        "Wrong items or missing items in the package",
        "Eligible non-perishable products returned within the allowed return window"
      ]
    },
    {
      heading: "2. Non-Returnable Categories",
      paragraphs: [
        "Some categories may not be accepted for return because of hygiene, customization, perishability, or regulatory restrictions."
      ],
      list: [
        "Opened personal care or hygiene-sensitive products unless defective",
        "Perishable goods or short shelf-life items",
        "Customized or special-order items",
        "Any product explicitly marked non-returnable on the listing or invoice"
      ]
    },
    {
      heading: "3. Cancellation and Refund Timelines",
      paragraphs: [
        "Orders may usually be cancelled before dispatch. After dispatch, a return request may be required instead of direct cancellation.",
        "Approved refunds are processed back to the original payment method or an equivalent supported channel after verification."
      ],
      list: [
        "Prepaid orders: refund initiated after cancellation or return approval",
        "Cash on delivery orders: refund issued through the supported settlement workflow",
        "Refund timing can vary depending on payment partner, bank, and verification status"
      ]
    },
    {
      heading: "4. How to Raise a Request",
      paragraphs: [
        "Users should raise the issue from their order history when available or use support if they cannot access the order section."
      ],
      list: [
        { label: "Contact Us", to: "/contact", description: "Raise cancellation, return, or refund questions" },
        { label: "Help & Support", to: "/help-support", description: "See the standard support flow and expected response steps" }
      ],
      note:
        "Supporting photos, order references, or delivery details may be requested before approval."
    }
  ],
  footerNote:
    "If a product listing or invoice states a more specific return condition, that product-level condition will also apply."
};

export const shippingDocument = {
  title: "Shipping & Delivery Policy",
  badge: "Operational Policy",
  lastUpdated: "19 April 2026",
  meta: "Dispatch, delivery, and logistics expectations",
  intro:
    "This page explains how Aarogyam Rahita handles shipping, estimated delivery timelines, dispatch communication, and delivery-related exceptions.",
  sections: [
    {
      heading: "1. Service Coverage",
      paragraphs: [
        "Delivery availability depends on serviceable pin codes, item type, stock position, and courier support.",
        "Some items may have limited coverage due to size, regulation, or special handling requirements."
      ]
    },
    {
      heading: "2. Dispatch and Delivery Timelines",
      paragraphs: [
        "Estimated dispatch and delivery windows are shown during checkout or order confirmation where available.",
        "Actual timelines can vary due to stock sync, logistics capacity, public holidays, weather, address issues, or operational events outside direct control."
      ],
      list: [
        "Orders are usually dispatched after payment confirmation or order verification",
        "Split shipments may occur when items are sourced from different stocks or require different handling",
        "Delivery updates may be shared through app notifications, SMS, phone, or email depending on the enabled channels"
      ]
    },
    {
      heading: "3. Delivery Attempts and Address Accuracy",
      paragraphs: [
        "Users are responsible for providing correct delivery details, reachable contact numbers, and any landmark information needed for successful handover.",
        "Repeated failed delivery attempts caused by incorrect information or non-availability may lead to cancellation or return-to-origin processing."
      ]
    },
    {
      heading: "4. Delays, Damages, and Escalation",
      paragraphs: [
        "If an order is delayed beyond the expected window, or if a package arrives damaged, users should raise the issue with the support team as early as possible."
      ],
      list: [
        { label: "Contact Us", to: "/contact", description: "Escalate delayed or damaged deliveries" },
        { label: "Return & Refund Policy", to: "/returnRefund", description: "See handling of delivery-related return outcomes" }
      ]
    }
  ],
  footerNote:
    "Estimated timelines are indicative and not guaranteed unless an explicit commitment is stated for the relevant order."
};

export const accountDeletionDocument = {
  title: "Account & Data Deletion",
  badge: "Play Store Support",
  lastUpdated: "19 April 2026",
  meta: "Delete your account or request data removal",
  intro:
    "This page explains how users can request deletion of their Aarogyam Rahita account and what happens to associated data after a deletion request is submitted.",
  sections: [
    {
      heading: "1. How to Request Deletion",
      paragraphs: [
        "If you want your account removed, submit a request through the support channels and mention the phone number or email linked to the account.",
        "For security reasons, we may verify ownership before processing the request."
      ],
      list: [
        { label: "Contact Us", to: "/contact", description: "Submit the deletion request from the public contact form" },
        { label: "Help & Support", to: "/help-support", description: "See the support workflow before raising the request" }
      ]
    },
    {
      heading: "2. What Gets Deleted",
      paragraphs: [
        "After verification, profile details and user-linked personal information that are no longer required for operational or legal purposes will be removed or anonymized."
      ],
      list: [
        "Profile details such as name, login identifiers, and saved personal preferences",
        "Stored addresses and non-essential support references linked to the account",
        "Other personal information that no longer needs to be retained"
      ]
    },
    {
      heading: "3. What May Be Retained",
      paragraphs: [
        "Certain records may remain for legal, tax, fraud-prevention, dispute-resolution, or bookkeeping obligations even after the account is deleted."
      ],
      list: [
        "Invoices and transaction records where retention is legally required",
        "Security logs needed to investigate abuse or protect the platform",
        "Minimal records proving that a deletion request was processed"
      ]
    },
    {
      heading: "4. Processing Time",
      paragraphs: [
        "Deletion requests are reviewed manually. Processing time depends on verification, unresolved orders, open disputes, or pending legal obligations.",
        "If any active order or payment issue is still open, deletion may be delayed until that workflow is closed."
      ]
    }
  ],
  footerNote:
    "Deleting the account may prevent future access to order history, saved addresses, and profile-based features."
};

export const userContentDocument = {
  title: "User Content Policy",
  badge: "Community Rules",
  lastUpdated: "19 April 2026",
  meta: "Applies to videos, posts, comments, images, and uploads",
  intro:
    "If users submit posts, videos, reviews, images, or any other content through Aarogyam Rahita, this policy explains the basic quality, safety, and moderation rules that apply.",
  sections: [
    {
      heading: "1. Allowed Content",
      paragraphs: [
        "User submissions should be relevant to the platform, factually responsible, and lawful to share.",
        "You must only upload content that you own or are authorized to use."
      ]
    },
    {
      heading: "2. Restricted Content",
      paragraphs: [
        "Content may be rejected, hidden, or removed if it violates law, harms users, or creates moderation risk."
      ],
      list: [
        "Misleading medical or product claims",
        "Spam, fraud, impersonation, or deceptive promotions",
        "Content that infringes copyrights, trademarks, or privacy rights",
        "Material that is unsafe, abusive, illegal, or operationally harmful to the platform"
      ]
    },
    {
      heading: "3. Moderation and Enforcement",
      paragraphs: [
        "The platform may review, edit, restrict, or delete user content and may suspend related accounts where policy violations are detected.",
        "Moderation decisions may be based on internal review, complaints, legal requests, or product safety concerns."
      ]
    },
    {
      heading: "4. Reporting Issues",
      paragraphs: [
        "If you believe content violates your rights or platform rules, raise a report through the support team with relevant details."
      ],
      list: [
        { label: "Contact Us", to: "/contact", description: "Report infringing, unsafe, or misleading content" }
      ]
    }
  ],
  footerNote:
    "Submitting content does not transfer ownership, but it does allow the platform to display and moderate that content for service operation."
};

export const helpSupportDocument = {
  title: "Help & Support",
  badge: "Public Support Page",
  lastUpdated: "19 April 2026",
  meta: "How users can get assistance",
  intro:
    "This page explains the main support routes available to Aarogyam Rahita users for account, order, delivery, refund, privacy, and technical issues.",
  sections: [
    {
      heading: "1. Best Ways to Reach Support",
      paragraphs: [
        "Use the most relevant channel so the request can be routed faster. Include order IDs, phone number, or account email when available."
      ],
      list: [
        { label: "Contact Us", to: "/contact", description: "General support, complaints, privacy questions, and escalation requests" },
        { label: "FAQ", to: "/faq", description: "Answers for common order, account, payment, and delivery questions" },
        { label: "Account & Data Deletion", to: "/account-deletion", description: "Request account deletion or personal data removal" }
      ]
    },
    {
      heading: "2. What to Include in a Support Request",
      paragraphs: [
        "A clear request helps support resolve the issue with fewer follow-ups."
      ],
      list: [
        "Registered name, phone number, or email linked to the account",
        "Order ID, invoice number, or delivery reference where applicable",
        "Short description of the issue and the expected resolution",
        "Screenshots or media only when needed to prove an app, order, or delivery issue"
      ]
    },
    {
      heading: "3. Support Topics Covered",
      list: [
        "Account login and profile issues",
        "Order placement, status, and invoice questions",
        "Delivery delays or damaged packages",
        "Refund or cancellation follow-ups",
        "Privacy, data, or deletion requests",
        "Videos, posts, and user content reports"
      ]
    }
  ],
  footerNote:
    "Before publishing the Android app, make sure the official support email or phone details used by the business are also reflected consistently in app store listing content if required."
};

export const siteMapDocument = {
  title: "Site Map",
  badge: "Quick Navigation",
  lastUpdated: "19 April 2026",
  meta: "Main public pages available from the footer",
  intro:
    "Use this page to quickly access major public sections, support pages, and legal documents available on Aarogyam Rahita.",
  sections: [
    {
      heading: "1. Shopping Pages",
      list: [
        { label: "Home", to: "/", description: "Landing page and featured products" },
        { label: "Products", to: "/products", description: "Browse product catalog" },
        { label: "Videos", to: "/videos", description: "Public media and share-post feed" },
        { label: "About", to: "/about", description: "Brand and platform overview" },
        { label: "Contact Us", to: "/contact", description: "Public support form" }
      ]
    },
    {
      heading: "2. Support Pages",
      list: [
        { label: "Help & Support", to: "/help-support", description: "Support channels and issue routing" },
        { label: "FAQ", to: "/faq", description: "Frequently asked questions" },
        { label: "Account & Data Deletion", to: "/account-deletion", description: "Delete account or request data removal" }
      ]
    },
    {
      heading: "3. Legal Pages",
      list: [
        { label: "Privacy Policy", to: "/privacy-policy", description: "How user data is collected and used" },
        { label: "Terms & Conditions", to: "/terms-and-conditions", description: "Rules for using the platform" },
        { label: "Shipping & Delivery Policy", to: "/shipping-delivery", description: "Dispatch and delivery rules" },
        { label: "Return & Refund Policy", to: "/returnRefund", description: "Cancellation, return, and refund terms" },
        { label: "User Content Policy", to: "/user-content-policy", description: "Rules for submitted content" }
      ]
    }
  ],
  footerNote:
    "All footer legal links are routed to public pages so users and reviewers can open them directly without signing in."
};